import React, { useState, useEffect } from 'react';
import { Container, Typography, Box } from '@mui/material';
import { SpreadsheetViewer } from './components/SpreadsheetViewer';
import { VideoManager } from './components/VideoManager';
import { UploadVideo } from './components/UploadVideo';
import { VOManager } from './components/VOManager';
import { VOEditor } from './components/VOEditor';
import { IntroOutroPage } from './components/IntroOutroPage';
import { OutputManager } from './components/OutputManager';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { parse, isValid, format } from 'date-fns';
import { SnackbarProvider } from 'notistack';
import './App.css';

// Google Drive folder ID containing the spreadsheets
const SHEETS_FOLDER_ID = '1lKOKrRzhCnmucj05yzvdy2kkl5H0_CG_';

function App() {
  const [selectedDate, setSelectedDate] = useState<Date | null>(() => {
    // Try to load the last viewed date from localStorage
    const savedDate = localStorage.getItem('lastViewedDate');
    if (savedDate) {
      const parsedDate = parse(savedDate, 'M-d-yy', new Date());
      return isValid(parsedDate) ? parsedDate : null;
    }
    return null;
  });
  
  // Add chartDate state
  const [chartDate, setChartDate] = useState<string>(() => {
    // Try to load the chart date from localStorage
    return localStorage.getItem('currentChartDate') || '';
  });

  // Save the selected date to localStorage whenever it changes
  useEffect(() => {
    if (selectedDate) {
      localStorage.setItem('lastViewedDate', format(selectedDate, 'M-d-yy'));
    }
  }, [selectedDate]);
  
  // Save chartDate to localStorage when it changes
  useEffect(() => {
    if (chartDate) {
      localStorage.setItem('currentChartDate', chartDate);
    }
  }, [chartDate]);

  return (
    <Router>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <SnackbarProvider maxSnack={3}>
        <Container maxWidth="lg" sx={{ fontFamily: "'Open Sans', sans-serif" }}>
          <Box sx={{ my: 4 }}>
            <Typography 
              variant="h4" 
              component="h1" 
              gutterBottom 
              align="center"
              sx={{
                fontFamily: "'Open Sans', sans-serif",
                fontWeight: 800
              }}
            >
              Billboard Hot 100 Chart Reveal {chartDate ? `- ${chartDate}` : ''}
            </Typography>
            <Routes>
              <Route 
                path="/" 
                element={
                  <SpreadsheetViewer 
                    spreadsheetId={SHEETS_FOLDER_ID}
                    selectedDate={selectedDate}
                    onDateChange={setSelectedDate}
                    setChartDate={setChartDate}
                  />
                } 
              />
              <Route path="/video-manager" element={<VideoManager />} />
              <Route path="/upload-video" element={<UploadVideo />} />
              <Route path="/vo-manager" element={<VOManager spreadsheetId={localStorage.getItem('currentSpreadsheetId') || undefined} />} />
              <Route path="/vo-editor" element={<VOEditor voLines={[]} />} />
              <Route path="/intro-outro" element={<IntroOutroPage setChartDate={setChartDate} />} />
                <Route path="/intro-outro/:renderSheetId" element={<IntroOutroPage setChartDate={setChartDate} />} />
              <Route path="/output-manager" element={<OutputManager spreadsheetId={localStorage.getItem('currentSpreadsheetId') || ''} />} />
            </Routes>
          </Box>
        </Container>
        </SnackbarProvider>
      </LocalizationProvider>
    </Router>
  );
}

export default App;
